import "./../styles/LegalPages.css";

function PrivacyPolicyPage() {

  return (

    <div className="legal-page">

      <div className="legal-container">

        <h1>
          Politique de confidentialité
        </h1>

        <p>
          Dernière mise à jour : Juin 2026
        </p>

        <section>
          <h2>1. Introduction</h2>
          <p>La présente Politique de confidentialité décrit la manière dont FootVision Live, accessible à l'adresse https://footvisionlive.com, collecte, utilise, protège, conserve et traite les données personnelles de ses utilisateurs.</p>
          <p>En utilisant FootVision Live, vous acceptez les pratiques décrites dans cette politique.</p>
        </section>

        <section>
          <h2>2. Responsable du traitement</h2>
          <p>Le responsable du traitement des données personnelles est :</p>
          <strong>Site Internet : https://footvisionlive.com</strong>
          <p>Adresse électronique :</p>
          <strong>contact@footvisionlive.com</strong>
        </section>

        <section>
          <h2>3. Champ d'application</h2>
          <p>La présente politique s'applique à tous les services proposés par FootVision Live, notamment :</p>
          <ul>
            <li>le site web ;</li>
            <li>les comptes utilisateurs ;</li>
            <li>les comptes VIP ;</li>
            <li>les analyses footballistiques ;</li>
            <li>les pronostics sportifs ;</li>
            <li>les compositions de matchs ;</li>
            <li>les paiements ;</li>
            <li>les services de connexion Google.</li>
          </ul>
        </section>

        <section>
          <h2>4. Données collectées</h2>
          <p>Selon votre utilisation de la plateforme, FootVision Live peut collecter notamment :</p>
          
          <h3>Données d'identification</h3>
          <ul>
            <li>nom d'utilisateur ;</li>
            <li>adresse électronique ;</li>
            <li>identifiant Google (si connexion Google).</li>
          </ul>

          <h3>Données du compte</h3>
          <ul>
            <li>date de création ;</li>
            <li>rôle utilisateur ;</li>
            <li>statut VIP ;</li>
            <li>date d'expiration VIP ;</li>
            <li>avatar.</li>
          </ul>

          <h3>Données techniques</h3>
          <ul>
            <li>adresse IP ;</li>
            <li>navigateur ;</li>
            <li>système d'exploitation ;</li>
            <li>appareil utilisé ;</li>
            <li>langue ;</li>
            <li>fuseau horaire.</li>
          </ul>

          <h3>Données de navigation</h3>
          <ul>
            <li>pages consultées ;</li>
            <li>durée des visites ;</li>
            <li>interactions avec le site ;</li>
            <li>clics sur certaines fonctionnalités.</li>
          </ul>

          <h3>Données de paiement</h3>
          <p>Les paiements sont traités par des prestataires spécialisés (par exemple Flutterwave).</p>
          <p>FootVision Live ne stocke jamais les numéros complets de carte bancaire.</p>
        </section>

        <section>
          <h2>5. Création d'un compte</h2>
          <p>Lors de la création d'un compte classique, les informations suivantes sont demandées :</p>
          <ul>
            <li>nom d'utilisateur ;</li>
            <li>adresse électronique ;</li>
            <li>mot de passe sécurisé.</li>
          </ul>
          <p>Le mot de passe est chiffré avant son stockage et n'est jamais conservé en clair.</p>
        </section>

        <section>
          <h2>6. Connexion Google</h2>
          <p>Lorsque vous choisissez la connexion avec Google, FootVision Live peut recevoir :</p>
          <ul>
            <li>vous nom ;</li>
            <li>votre adresse e-mail ;</li>
            <li>votre identifiant Google ;</li>
            <li>votre photo de profil (si disponible).</li>
          </ul>
          <p>Aucun mot de passe Google n'est transmis à FootVision Live. L'authentification est entièrement assurée par Google.</p>
        </section>

        <section>
          <h2>7. Utilisation des données</h2>
          <p>Les données collectées permettent notamment :</p>
          <ul>
            <li>de créer votre compte ;</li>
            <li>de sécuriser votre connexion ;</li>
            <li>d'activer votre abonnement VIP ;</li>
            <li>de personnaliser votre expérience ;</li>
            <li>d'améliorer la plateforme ;</li>
            <li>d'assurer le support utilisateur ;</li>
            <li>de prévenir les fraudes ;</li>
            <li>de protéger les comptes.</li>
          </ul>
        </section>

        <section>
          <h2>8. Base légale du traitement</h2>
          <p>Les traitements réalisés reposent notamment sur :</p>
          <ul>
            <li>votre consentement ;</li>
            <li>l'exécution du contrat d'utilisation de FootVision Live ;</li>
            <li>les obligations légales ;</li>
            <li>les intérêts légitimes de la plateforme.</li>
          </ul>
        </section>

        <section>
          <h2>9. Sécurité des données</h2>
          <p>FootVision Live met en œuvre différentes mesures destinées à protéger vos informations personnelles, notamment :</p>
          <ul>
            <li>chiffrement des mots de passe ;</li>
            <li>authentification sécurisée ;</li>
            <li>contrôle des accès ;</li>
            <li>surveillance des serveurs ;</li>
            <li>limitation des privilèges administrateurs ;</li>
            <li>mises à jour régulières.</li>
          </ul>
          <p>Malgré ces mesures, aucune technologie ne permet de garantir une sécurité absolue sur Internet.</p>
        </section>

        <section>
          <h2>10. Durée de conservation</h2>
          <p>Les données personnelles sont conservées uniquement pendant la durée nécessaire aux finalités pour lesquelles elles ont été collectées.</p>
          <p>Certaines informations peuvent être conservées plus longtemps lorsque la loi l'impose ou afin de permettre la défense des droits de FootVision Live.</p>
        </section>

        <section>
          <h2>11. Exactitude des informations</h2>
          <p>Chaque utilisateur s'engage à fournir des informations exactes et à les maintenir à jour.</p>
          <p>FootVision Live ne pourra être tenu responsable des conséquences résultant d'informations erronées fournies par l'utilisateur.</p>
        </section>

        <section>
          <h2>12. Protection des mineurs</h2>
          <p>FootVision Live ne collecte pas volontairement de données personnelles auprès de personnes ne remplissant pas les conditions d'utilisation prévues par la législation applicable.</p>
          <p>Tout représentant légal peut demander la suppression d'un compte créé en violation de cette règle.</p>
        </section>

        <section>
          <h2>13. Partage des données personnelles</h2>
          <p>FootVision Live ne vend jamais les données personnelles de ses utilisateurs.</p>
          <p>Les informations collectées peuvent toutefois être partagées uniquement lorsque cela est nécessaire avec :</p>
          <ul>
            <li>les prestataires techniques ;</li>
            <li>les fournisseurs d'hébergement ;</li>
            <li>les services d'authentification ;</li>
            <li>les prestataires de paiement ;</li>
            <li>les services d'analyse d'audience ;</li>
            <li>les autorités légalement compétentes lorsque la loi l'impose.</li>
          </ul>
        </section>

        <section>
          <h2>14. Hébergement des données</h2>
          <p>FootVision Live est hébergé sur les infrastructures de <strong>Render</strong>.</p>
          <p>Les données peuvent être stockées sur des serveurs situés dans différents pays selon l'infrastructure utilisée par Render.</p>
          <p>Render appliquant ses propres mesures de sécurité afin d'assurer la disponibilité et la protection des données hébergées.</p>
        </section>

        <section>
          <h2>15. Prestataire de paiement</h2>
          <p>Les paiements réalisés sur FootVision Live sont traités par <strong>Monnaie électronique</strong>.</p>
          <p>Lors d'un paiement, certaines informations peuvent être transmises directement au monnaie  électronique afin de :</p>
          <ul>
            <li>vérifier la transaction ;</li>
            <li>lutter contre la fraude ;</li>
            <li>confirmer le paiement ;</li>
            <li>gérer les remboursements lorsque cela est applicable.</li>
          </ul>
          <p>FootVision Live n'accède jamais aux informations bancaires complètes des utilisateurs.</p>
        </section>

        <section>
          <h2>16. Authentification Google</h2>
          <p>Lorsque l'utilisateur choisit de se connecter via Google :</p>
          <ul>
            <li>Google procède à l'authentification ;</li>
            <li>FootVision Live reçoit uniquement les informations autorisées par l'utilisateur.</li>
          </ul>
          <p>Les traitements réalisés par Google restent soumis à la politique de confidentialité de Google.</p>
        </section>

        <section>
          <h2>17. Google Analytics</h2>
          <p>FootVision Live peut utiliser Google Analytics afin de mesurer :</p>
          <ul>
            <li>le nombre de visiteurs ;</li>
            <li>les pages consultées ;</li>
            <li>les performances du site ;</li>
            <li>les comportements de navigation.</li>
          </ul>
          <p>Ces données sont principalement utilisées pour améliorer l'expérience utilisateur.</p>
        </section>

        <section>
          <h2>18. Google AdSense</h2>
          <p>FootVision Live peut diffuser des annonces publicitaires via Google AdSense.</p>
          <p>Google peut utiliser des cookies afin :</p>
          <ul>
            <li>d'afficher des annonces pertinentes ;</li>
            <li>de limiter les répétitions des publicités ;</li>
            <li>de mesurer les performances publicitaires.</li>
          </ul>
          <p>Les utilisateurs peuvent gérer leurs préférences publicitaires directement auprès de Google.</p>
        </section>

        <section>
          <h2>19. API-SPORTS</h2>
          <p>Certaines données sportives affichées sur FootVision Live proviennent du fournisseur API-SPORTS.</p>
          <p>Les informations récupérées concernent notamment :</p>
          <ul>
            <li>les rencontres ;</li>
            <li>les statistiques ;</li>
            <li>les compositions d'équipes ;</li>
            <li>les classements ;</li>
            <li>les événements de match.</li>
          </ul>
          <p>Ces données ne contiennent généralement aucune donnée personnelle concernant les utilisateurs de FootVision Live.</p>
        </section>

        <section>
          <h2>20. Journaux techniques</h2>
          <p>Afin d'assurer la sécurité de la plateforme, certains journaux techniques peuvent être enregistrés, notamment :</p>
          <ul>
            <li>adresse IP ;</li>
            <li>heure de connexion ;</li>
            <li>navigateur utilisé ;</li>
            <li>système d'exploitation ;</li>
            <li>erreurs techniques ;</li>
            <li>tentatives d'accès.</li>
          </ul>
          <p>Ces informations servent uniquement à protéger la plateforme, détecter les fraudes et améliorer la stabilité des services.</p>
        </section>

        <section>
          <h2>21. Cookies</h2>
          <p>FootVision Live utilise différents types de cookies. Ils permettent notamment :</p>
          <ul>
            <li>de maintenir la connexion des utilisateurs ;</li>
            <li>de mémoriser certaines préférences ;</li>
            <li>d'améliorer les performances du site ;</li>
            <li>de mesurer l'audience ;</li>
            <li>d'assurer certaines fonctionnalités.</li>
          </ul>
          <p>Une Politique relative aux cookies complète est disponible séparément.</p>
        </section>

        <section>
          <h2>22. Durée des cookies</h2>
          <p>Les cookies peuvent être :</p>
          <ul>
            <li>temporaires (supprimés à la fermeture du navigateur) ;</li>
            <li>persistants (conservés pendant une durée limitée).</li>
          </ul>
          <p>L'utilisateur peut supprimer ces cookies directement depuis son navigateur.</p>
        </section>

        <section>
          <h2>23. Securité des comptes</h2>
          <p>FootVision Live met en œuvre différentes mesures destinées à protéger les comptes utilisateurs, notamment :</p>
          <ul>
            <li>chiffrement des mots de passe ;</li>
            <li>authentification sécurisée ;</li>
            <li>limitation des accès administrateurs ;</li>
            <li>vérification des connexions.</li>
          </ul>
          <p>L'utilisateur reste néanmoins responsable de la confidentialité de ses identifiants.</p>
        </section>

        <section>
          <h2>24. Droits des utilisateurs</h2>
          <p>Conformément à la réglementation applicable, chaque utilisateur peut notamment demander :</p>
          <ul>
            <li>l'accès à ses données personnelles ;</li>
            <li>la rectification de données inexactes ;</li>
            <li>la suppression de son compte ;</li>
            <li>la limitation de certains traitements lorsque cela est légalement possible.</li>
          </ul>
          <p>Toute demande peut être adressée à : <strong>contact@footvisionlive.com</strong></p>
        </section>

        <section>
          <h2>25. Suppression du compte</h2>
          <p>L'utilisateur peut demander la suppression de son compte. La suppression entraîne notamment :</p>
          <ul>
            <li>la désactivation de l'accès au compte ;</li>
            <li>la suppression progressive des données non soumises à une obligation légale de conservation.</li>
          </ul>
          <p>Certaines informations pourront être conservées lorsque la loi l'impose ou afin de protéger les droits de FootVision Live.</p>
        </section>

        <section>
          <h2>26. Conservation des obligations légales</h2>
          <p>Même après la suppression d'un compte, certaines informations peuvent être conservées afin :</p>
          <ul>
            <li>de respecter les obligations légales ;</li>
            <li>de prévenir les fraudes ;</li>
            <li>de répondre à une demande judiciaire ;</li>
            <li>d'assurer la défense des droits de FootVision Live.</li>
          </ul>
        </section>

        <section>
          <h2>27. Transfert international des données</h2>
          <p>Selon les services utilisés (Google, Render, Flutterwave, etc.), certaines données peuvent être traitées ou hébergées dans différents pays.</p>
          <p>FootVision Live sélectionne des partenaires appliquant des mesures de sécurité reconnues.</p>
        </section>

        <section>
          <h2>28. Modification de la présente politique</h2>
          <p>FootVision Live peut modifier la présente Politique de confidentialité afin de tenir compte des évolutions légales, d'améliorer ses services ou d'ajouter de nouvelles fonctionnalités.</p>
          <p>Les utilisateurs sont invités à consulter régulièrement cette politique.</p>
        </section>

        <section>
          <h2>29. Contact</h2>
          <p>Pour toute question concernant la présente Politique de confidentialité, vous pouvez contacter FootVision Live à :</p>
          <strong>contact@footvisionlive.com</strong>
        </section>

        <section>
          <h2>30. Entrée en vigueur</h2>
          <p>La présente Politique de confidentialité entre en vigueur dès sa publication sur FootVision Live et demeure applicable jusqu'à son remplacement par une version plus récente.</p>
        </section>

      </div>

    </div>

  );

}

export default PrivacyPolicyPage;
